import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, token: String }

  perform() {
    fetch(this.urlValue, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": this.tokenValue,
        "Accept": "text/html"
      }
    }).then(() => {
      window.location.href = "/"
    })
  }
}
